import { render, staticRenderFns } from "./UserAccess.vue?vue&type=template&id=149e8706&scoped=true"
import script from "./UserAccess.vue?vue&type=script&lang=js"
export * from "./UserAccess.vue?vue&type=script&lang=js"
import style0 from "./UserAccess.vue?vue&type=style&index=0&id=149e8706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149e8706",
  null
  
)

export default component.exports